<template>
  <div class="kkprl-chart-card shadow-sm rounded-4 p-4">
    <!-- Header Section -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h5 class="chart-title fw-bold m-0">Jumlah Perubahan KKPRL</h5>
        <small class="text-muted">Data statistik perubahan tahun {{ tahun }}</small>
      </div>
      <div class="badge bg-primary-subtle text-primary fw-semibold px-3 py-2 rounded-pill">
        Tahun {{ tahun }}
      </div>
    </div>

    <!-- State Loading -->
    <div v-if="isLoading" class="state-container d-flex flex-column align-items-center justify-content-center">
      <div class="spinner-border text-primary mb-2" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <small class="text-muted">Memuat data...</small>
    </div>

    <!-- State Data Kosong (Empty State) -->
    <div v-else-if="isEmpty" class="state-container d-flex flex-column align-items-center justify-content-center text-center p-4">
      <div class="empty-icon-box mb-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="text-secondary">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <h6 class="fw-semibold text-dark mb-1">Data Tidak Tersedia</h6>
      <p class="text-muted small mb-3" style="max-width: 300px;">
        Belum ada catatan perubahan KKPRL yang terdaftar pada tahun {{ tahun }}.
      </p>
      <button class="btn btn-sm btn-outline-primary rounded-pill px-3" @click="loadDataChart">
        Segarkan Data
      </button>
    </div>

    <!-- Chart Wrapper -->
    <div v-else class="chart-wrapper">
      <apexchart
        type="bar"
        height="350"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'JumlahPerubahanKKPRLChart',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    tahun: {
      type: [String, Number],
      default: new Date().getFullYear(),
    },
  },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user') || '{}'),
      isLoading: false,
      isEmpty: false,
      series: [
        {
          name: 'Jumlah Perubahan',
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          toolbar: { show: true },
          fontFamily: 'Inter, system-ui, sans-serif',
        },
        plotOptions: {
          bar: {
            horizontal: true,
            columnWidth: '55%',
            borderRadius: 8,
          },
        },
        colors: ['#06b6d4'],
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'horizontal',
            gradientToColors: ['#3b82f6'],
            stops: [0, 100],
          },
        },
        dataLabels: { enabled: true },
        xaxis: { categories: [] },
      },
    }
  },
  methods: {
    async loadDataChart() {
      this.isLoading = true
      this.isEmpty = false

      try {
        const res = await axios.get(
          `${this.baseapi}api/dashboard/getJumlahPerubahanKKPRL?tahun=${this.tahun}`,
          {
            headers: {
              Authorization: `Bearer ` + (this.user?.accessToken || ''),
            },
          }
        )
        const data = res.data.data
        const seriesData = data?.series || []

        // Pengecekan data kosong (array kosong atau semua bernilai 0)
        const totalValue = seriesData.reduce((acc, curr) => acc + (Number(curr) || 0), 0)

        if (!seriesData.length || totalValue === 0) {
          this.isEmpty = true
        } else {
          this.series = [{ name: 'Jumlah Perubahan', data: seriesData }]
          this.chartOptions = {
            ...this.chartOptions,
            xaxis: { categories: data.labels || [] },
          }
        }
      } catch (error) {
        this.isEmpty = true
      } finally {
        this.isLoading = false
      }
    },
  },
  watch: {
    tahun: {
      handler() {
        this.loadDataChart()
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>
.kkprl-chart-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.state-container {
  min-height: 350px;
}

.empty-icon-box {
  width: 64px;
  height: 64px;
  background-color: #f8fafc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #cbd5e1;
}
</style>